/** Auto-generated from prod_faq - do not edit by hand */

export const FAQ_CATEGORY_ORDER = [
  'Personal Injury',
  'Motor Vehicle',
  'Premises Liability',
  'Catastrophic Injury',
  'Workplace Injury',
  'Estate & Probate',
  'Real Estate Law'
];

export const faqRoutes = [
  { slug: 'can-i-recover-if-partially-at-fault', title: 'Can I Still Recover If I Was Partially at Fault?', category: 'Personal Injury' },
  { slug: 'should-i-hire-a-lawyer-after-a-minor-accident', title: 'Do I Need a Lawyer After a "Minor" Car Accident?', category: 'Personal Injury' },
  { slug: 'how-do-i-choose-a-personal-injury-lawyer', title: 'How Do I Choose a Personal Injury Lawyer?', category: 'Personal Injury' },
  { slug: 'what-should-i-do-after-a-car-accident', title: 'What Should I Do After a Car Accident in Georgia?', category: 'Personal Injury' },
  { slug: 'dui-accidents', title: 'What Should I Know About Drunk Driving (DUI) Accidents in Georgia?', category: 'Motor Vehicle' },
  { slug: 'motor-vehicle-accidents', title: 'What Should I Know About Motor Vehicle Accidents in Georgia?', category: 'Motor Vehicle' },
  { slug: 'motorcycle-accidents', title: 'What Should I Know About Motorcycle Accidents in Georgia?', category: 'Motor Vehicle' },
  { slug: 'truck-accidents', title: 'What Should I Know About Truck & 18-Wheeler Accidents in Georgia?', category: 'Motor Vehicle' },
  { slug: 'rideshare-accidents', title: 'What Should I Know About Uber & Lyft Accidents in Georgia?', category: 'Motor Vehicle' },
  { slug: 'inadequate-maintenance', title: 'What Counts as Inadequate Property Maintenance in Georgia?', category: 'Premises Liability' },
  { slug: 'negligent-security', title: 'What Is Negligent Security in Georgia?', category: 'Premises Liability' },
  { slug: 'premises-liability', title: 'What Is Premises Liability in Georgia?', category: 'Premises Liability' },
  { slug: 'slip-and-fall', title: 'What Should I Know About Slip and Fall Claims in Georgia?', category: 'Premises Liability' },
  { slug: 'swimming-pool-accidents', title: 'What Should I Know About Swimming Pool Accidents in Georgia?', category: 'Premises Liability' },
  { slug: 'wrongful-death', title: 'What Is a Wrongful Death Claim in Georgia?', category: 'Catastrophic Injury' },
  { slug: 'catastrophic-injury', title: 'What Is Considered a Catastrophic Injury in Georgia?', category: 'Catastrophic Injury' },
  { slug: 'paralysis', title: 'What Should I Know About Paralysis Injury Claims in Georgia?', category: 'Catastrophic Injury' },
  { slug: 'spinal-cord-injury', title: 'What Should I Know About Spinal Cord Injury Claims in Georgia?', category: 'Catastrophic Injury' },
  { slug: 'traumatic-brain-injury', title: 'What Should I Know About Traumatic Brain Injury (TBI) Claims in Georgia?', category: 'Catastrophic Injury' },
  { slug: 'contractor-negligence', title: 'What Is Contractor Negligence in Georgia?', category: 'Workplace Injury' },
  { slug: 'construction-accidents', title: 'What Should I Know About Construction Accidents in Georgia?', category: 'Workplace Injury' },
  { slug: 'workplace-industrial-injury', title: 'What Should I Know About Workplace & Industrial Injuries in Georgia?', category: 'Workplace Injury' },
  { slug: 'workplace-injuries', title: 'What Should I Know About Workplace Injuries in Georgia?', category: 'Workplace Injury' },
  { slug: 'contested-probate', title: 'What Are Contested Probate Proceedings in Georgia?', category: 'Estate & Probate' },
  { slug: 'creditor-claims-estate', title: 'What Are Creditor Claims Against an Estate in Georgia?', category: 'Estate & Probate' },
  { slug: 'estate-fraud', title: 'What Are Estate Fraud Claims in Georgia?', category: 'Estate & Probate' },
  { slug: 'guardianship-disputes', title: 'What Are Guardianship Disputes in Georgia?', category: 'Estate & Probate' },
  { slug: 'will-contests-trust-disputes', title: 'What Are Will Contests & Trust Disputes in Georgia?', category: 'Estate & Probate' },
  { slug: 'executor-misconduct', title: 'What Counts as Executor Misconduct in Georgia?', category: 'Estate & Probate' },
  { slug: 'undue-influence', title: 'What Is an Undue Influence Claim in Georgia?', category: 'Estate & Probate' },
  { slug: 'breach-fiduciary-duty', title: 'What Is Breach of Fiduciary Duty in an Estate or Trust?', category: 'Estate & Probate' },
  { slug: 'disputed-probate-administration', title: 'What Is Disputed Probate Administration in Georgia?', category: 'Estate & Probate' },
  { slug: 'estate-planning', title: 'What Should I Know About Estate Planning & Probate in Georgia?', category: 'Estate & Probate' },
  { slug: 'what-counts-as-a-commercial-lease-dispute', title: 'What Counts as a Commercial Lease Dispute?', category: 'Real Estate Law' },
  { slug: 'what-is-a-quiet-title-action', title: 'What Is a Quiet Title Action?', category: 'Real Estate Law' },
  { slug: 'real-estate-litigation', title: 'What Is Real Estate Law Litigation in Georgia?', category: 'Real Estate Law' },
  { slug: 'when-can-a-landlord-keep-my-security-deposit', title: 'When Can a Landlord Keep My Security Deposit in Georgia?', category: 'Real Estate Law' },
  { slug: 'when-do-i-need-a-partition-action', title: 'When Do I Need a Partition Action?', category: 'Real Estate Law' }
];

export const learnSlugRedirects = {
  'car-accidents': 'what-should-i-do-after-a-car-accident'
};

export const faqContent = {
  'breach-fiduciary-duty': { title: 'What Is Breach of Fiduciary Duty in an Estate or Trust?', category: 'Estate & Probate', body: `# BREACH OF FIDUCIARY DUTY

Trustees, executors, and administrators are entrusted to manage estates with integrity and transparency. When personal interests overshadow this duty, significant legal consequences can follow.

---

## Examples of Fiduciary Breach

- Misuse of trust funds
- Failure to diversify investments
- Improper distributions
- Withholding required disclosures
- Commingling personal and estate funds

These cases often involve complex financial records and require forensic analysis.

---

## Recoverable Damages

Courts may award:

- Restoration of lost funds
- Removal of fiduciary
- Attorneys' fees
- Interest and penalties` },
  'can-i-recover-if-partially-at-fault': { title: 'Can I Still Recover If I Was Partially at Fault?', category: 'Personal Injury', body: `**Yes — if you're less than 50% at fault.**

Georgia uses **modified comparative negligence** (O.C.G.A. § 51-12-33). You can recover damages as long as you aren't mostly responsible for the accident.

**How does fault affect my payout?**

Your award is reduced by your share of fault. Example: \$100,000 in damages and 20% fault → you recover \$80,000.

**What if I'm 50% or more at fault?**

You recover nothing under Georgia law.

**Who decides fault?**

Insurance adjusters assign fault first — often in their favor. If the case goes to court, a judge or jury decides.

**Do I need a lawyer?**

If the other side is blaming you, yes. An attorney pushes back on inflated fault assignments and protects your recovery.` },
  'catastrophic-injury': { title: 'What Is Considered a Catastrophic Injury in Georgia?', category: 'Catastrophic Injury', body: `# Catastrophic Injury

Catastrophic injuries permanently change lives. They do not simply require short-term treatment — they often involve lifelong medical care, loss of independence, and significant financial hardship.

If you or a loved one suffered a life-altering injury due to negligence in Georgia, you may be entitled to substantial compensation.

At Jones & Booth Law, we represent individuals and families throughout Georgia in complex catastrophic injury claims involving motor vehicle accidents, construction accidents, unsafe property conditions, equipment failures, and other serious incidents.

These cases require aggressive litigation strategy, expert testimony, and careful calculation of future damages.

---

## What is a Catastrophic Injury in Georgia?

A catastrophic injury typically involves permanent impairment, long-term disability, or significant loss of bodily function.

**Examples include:**
- Traumatic brain injury (TBI)
- Spinal cord injury
- Paralysis (paraplegia or quadriplegia)
- Amputation or loss of limb
- Severe burn injury
- Permanent neurological damage
- Multiple complex fractures
- Organ failure
- Loss of vision or hearing
- Wrongful death

These injuries often result in permanent loss of earning capacity and diminished quality of life.

---

## How Are These Cases Different Than A Regular Injury Claim?

Catastrophic injury cases require:

- Life care planning analysis
- Future medical cost projections
- Vocational rehabilitation experts
- Economic damage modeling
- Medical specialist testimony
- Trial-ready case development

Insurance companies defend these claims aggressively because potential damages are substantial. Early legal intervention is critical.

---

## Lifetime Costs of Catastrophic Injury

**Compensation may include:**
- Emergency medical care
- Hospitalization and surgery
- Rehabilitation and therapy
- Assistive devices
- Home modifications
- In-home nursing care
- Lost wages
- Loss of earning capacity
- Pain and suffering
- Emotional distress
- Loss of consortium
- Punitive damages (when applicable)

In severe cases, lifetime care costs can reach millions of dollars. Accurate valuation requires expert analysis — not insurance company estimates.

---

## What To Do After a Catastrophic Injury

1. Seek immediate and ongoing medical care.
2. Preserve documentation and records.
3. Avoid giving recorded statements to insurers without legal guidance.
4. Document how the injury affects daily life.
5. Consult an experienced catastrophic injury attorney promptly.

---

## How Insurance Companies Fight Catastrophic Injury Claims

- Minimize future care projections
- Dispute long-term impairment
- Shift partial blame to the injured party
- Rush early settlement offers
- Challenge medical necessity

We prepare every catastrophic injury case as though it will proceed to trial.` },
  'construction-accidents': { title: 'What Should I Know About Construction Accidents in Georgia?', category: 'Workplace Injury', body: `# Construction Accidents

Construction sites are among the most dangerous workplaces in Georgia. When safety protocols are ignored, equipment is improperly maintained, or contractors fail to follow regulations, workers and bystanders can suffer catastrophic injuries.

At Jones & Booth Law, we represent individuals injured in construction accidents throughout Georgia. While workers' compensation may provide limited benefits, many construction injury cases involve third-party liability claims that allow for full recovery of damages — including pain and suffering.

---

## Common Causes of Construction Accidents in Georgia

- Falls from scaffolding or ladders
- Roof falls
- Falling objects
- Crane accidents
- Forklift accidents
- Electrical injuries
- Trench collapses
- Structural failures
- Safety harness failures

Falls remain one of the leading causes of construction fatalities nationwide.

---

## Third-Party Construction Injury Claims

Responsible parties may include:

- General contractors
- Subcontractors
- Property owners
- Equipment manufacturers
- Site managers
- Engineering firms

Unlike workers' compensation, third-party claims allow recovery for:

- Full lost wages
- Pain and suffering
- Future earning capacity
- Permanent disability
- Punitive damages (when applicable)

---

## Catastrophic Injuries on Construction Sites

- Traumatic brain injury
- Spinal cord injury
- Paralysis
- Amputation
- Severe burns
- Wrongful death` },
  'contested-probate': { title: 'What Are Contested Probate Proceedings in Georgia?', category: 'Estate & Probate', body: `# CONTESTED PROBATE PROCEEDINGS

When heirs clash, creditors make claims, or the validity of estate documents is challenged, probate can become highly contentious.

Our team guides you through contested probate situations across Georgia, advocating for beneficiaries, heirs, and fiduciaries.

---

## Common Probate Disputes

- Challenges to will validity
- Disagreements over asset distribution
- Appointment disputes for executors or administrators
- Accounting objections
- Creditor objections
- Heirship disputes

---

## Protecting Your Inheritance Rights

If you fail to object properly during probate, you may lose your ability to challenge decisions later. We guide clients through:

- Filing caveats
- Responding to objections
- Litigating evidentiary hearings
- Protecting beneficiary rights` },
  'contractor-negligence': { title: 'What Is Contractor Negligence in Georgia?', category: 'Workplace Injury', body: `# Contractor Negligence

Contractors have a legal duty to perform work safely and in compliance with industry standards. When contractors cut corners, ignore safety protocols, or fail to supervise workers properly, serious injuries can occur.

Contractor negligence claims often arise in construction, renovation, infrastructure, and commercial development projects.

---

## Examples of Contractor Negligence

- Failure to follow OSHA safety standards
- Improper scaffolding installation
- Unsafe trenching practices
- Inadequate site supervision
- Failure to secure equipment
- Electrical code violations
- Improper load securing

---

## Who Is Responsible?

Liability may extend to:

- General contractors
- Subcontractors
- Project managers
- Property owners
- Engineering consultants

Construction contracts and insurance policies often complicate liability analysis. A detailed investigation is necessary to determine responsibility.

---

## Compensation in Contractor Negligence Cases in Georgia

- Medical expenses
- Future medical care
- Lost wages
- Loss of earning capacity
- Pain and suffering
- Permanent disability damages
- Wrongful death damages (in fatal cases)

---

## Why These Cases Require Aggressive Representation

Contractors and their insurers often move quickly to control the narrative after a serious accident. Early legal intervention helps secure documentation, preserve site evidence, and prevent blame-shifting.` },
  'creditor-claims-estate': { title: 'What Are Creditor Claims Against an Estate in Georgia?', category: 'Estate & Probate', body: `# Creditor Claims Against the Estate

When someone passes away, creditors may file claims against the estate for unpaid debts. These claims can turn into disputes over validity, timeliness, or priority payment.

---

## Common Creditor Claims

- Outstanding medical bills and hospital expenses
- Nursing home or long-term care facility charges
- Credit card debt
- Personal loans and promissory notes
- Mortgage deficiencies or foreclosure balances
- HELOC
- Auto loan balances
- Unpaid property taxes
- State or federal tax liabilities
- Judgments from prior lawsuits
- Secured liens against real property
- And more

Georgia probate law establishes strict deadlines and priority rules. Executors must carefully determine whether each claim is valid, enforceable, timely filed, and properly classified.

---

## Common Creditor Claims Issues

- Disputed debt validity
- Expired claims
- Improper notice
- Secured vs. unsecured claims
- Insolvent estates` },
  'disputed-probate-administration': { title: 'What Is Disputed Probate Administration in Georgia?', category: 'Estate & Probate', body: `# DISPUTED PROBATE ADMINISTRATION

Executors and administrators have a legal obligation to manage estate assets responsibly and with transparency. When beneficiaries suspect mismanagement or misconduct, contentious disputes can arise.

---

## Signs of Probate Administration Problems

- Delayed distributions
- Failure to provide accounting
- Suspicious financial transactions
- Conflicts of interest
- Sale of estate property below market value
- Refusal to communicate

Georgia law requires fiduciaries to act in the best interests of beneficiaries and preserve estate assets.

---

## Legal Remedies May Include

- Court-ordered accounting
- Removal of executor
- Surcharge for financial losses
- Injunctive relief
- Recovery of misappropriated funds` },
  'dui-accidents': { title: 'What Should I Know About Drunk Driving (DUI) Accidents in Georgia?', category: 'Motor Vehicle', body: `# Drunk Driving Accidents

In Georgia, accidents resulting from drunk driving can lead to significant injuries to the victims and severe legal consequences for the responsible party.

Under Georgia law, victims of these accidents may be entitled to punitive damages, which are intended to punish the wrongdoer and deter similar behavior in the future.

## Punitive Damages

Punitive damages are awarded in addition to compensatory damages awarded in a normal motor vehicle collision, which cover medical expenses, lost wages, and property damage.

To qualify for punitive damages, the plaintiff must generally prove that the driver acted with gross negligence or willful misconduct.

## Contact Us Today

If you or a loved one has been involved in a drunk driving accident, it's crucial to call us today to understand your rights and explore potential compensation options.

Our experienced legal team is here to help you navigate the complexities of personal injury claims and fight for the justice you deserve. Contact us today for a free consultation.` },
  'estate-fraud': { title: 'What Are Estate Fraud Claims in Georgia?', category: 'Estate & Probate', body: `# Estate Fraud Claims

Estate fraud can occur both before and after a loved one's passing. Forms include forged documents, altered estate plans, and misappropriation of assets.

---

## Common Estate Fraud Scenarios

- Forged wills
- Fraudulent beneficiary designations
- Asset concealment
- Power of attorney abuse
- Financial exploitation of elderly individuals

Fraud claims often overlap with undue influence and fiduciary breach.

---

## Investigative Approach

We work with:

- Forensic accountants
- Handwriting experts
- Financial investigators
- Medical professionals

Estate fraud cases require strong evidentiary development and aggressive courtroom advocacy.` },
  'estate-planning': { title: 'What Should I Know About Estate Planning & Probate in Georgia?', category: 'Estate & Probate', body: `# Estate Planning and Probate Matters

Planning for the future is one of the most important steps you can take to protect your family, your assets, and your legacy.

At Jones & Booth Law, we assist individuals and families across Georgia with comprehensive estate planning and probate matters. Our goal is simple: protect your wishes, minimize conflict, and ensure smooth asset transition.

---

## Estate Planning Services

- Last Will and Testament drafting
- Revocable living trusts
- Durable financial powers of attorney
- Advance healthcare directives
- Guardianship designations for minor children
- Asset protection planning
- Beneficiary coordination
- Trust administration guidance

We also review and update outdated estate plans to reflect life changes.

---

## Why Estate Planning Matters

Without a valid estate plan, your assets may be distributed under Georgia's intestacy laws, which may not reflect your wishes.

Additionally:
- Probate proceedings become public record
- Family disputes are more likely
- Court-appointed administrators may control asset distribution
- Delays and additional expenses may arise

---

## Guiding Families Through Probate Process

Probate in Georgia involves:

- Validating the will (if one exists)
- Appointing an executor or administrator
- Identifying and inventorying assets
- Notifying creditors
- Paying valid debts
- Distributing remaining assets

---

## Probate Services We Handle

- Filing petitions for probate
- Executor appointment
- Estate administration
- Creditor claim review
- Asset inventory and valuation
- Heirship determinations
- Disputed probate proceedings
- Probate litigation
- Guardianship matters` },
  'executor-misconduct': { title: 'What Counts as Executor Misconduct in Georgia?', category: 'Estate & Probate', body: `# EXECUTOR MISCONDUCT

Executors hold a vital role in managing estate affairs with care and integrity. When that trust is broken, significant financial losses for beneficiaries can result.

---

## Executor Misconduct May Include

- Self-dealing
- Embezzlement
- Failure to distribute assets
- Concealment of estate property
- Conflicts of interest
- Improper investment decisions

Georgia law imposes fiduciary duties of loyalty, prudence, and impartiality on executors.

---

## Legal Remedies

Beneficiaries may petition the court to:

- Remove the executor
- Compel accounting
- Recover financial losses
- Freeze estate assets

Timely legal action is critical to prevent further depletion of estate assets.` },
  'guardianship-disputes': { title: 'What Are Guardianship Disputes in Georgia?', category: 'Estate & Probate', body: `# Georgia Guardianship Disputes

Guardianship proceedings determine who will make important decisions for individuals who cannot do so for themselves. These cases can be both emotionally charged and legally intricate.

---

## Common Reasons for Dispute

- Appointment of guardian
- Removal of guardian
- Financial management concerns
- Allegations of abuse or neglect

Georgia courts will always prioritize the best interests of the ward.

---

## Protecting Vulnerable Individuals

Our team represents family members, proposed guardians, and individuals contesting guardianship. Our mission: protect vulnerable individuals while ensuring decision-making authority is executed lawfully and ethically.` },
  'how-do-i-choose-a-personal-injury-lawyer': { title: 'How Do I Choose a Personal Injury Lawyer?', category: 'Personal Injury', body: `**Don't hire the first name you see on a billboard.** Ads aren't proof of quality.

**Research first.**

- Check the State Bar of Georgia for discipline history
- Read reviews, but verify they're genuine
- Look at experience with cases like yours — not just total years practicing

**Interview before you sign.**

Ask directly:

- Who will actually handle my case?
- Have you taken cases like mine to trial?
- How do you charge — contingency fee or hourly?
- How will you communicate with me?

**Red flags:**

- No callback within a few business days
- Vague answers about fees or timeline
- Pressure to sign immediately
- Can't explain your options in plain English

**Trust your gut.** You should feel heard, not rushed. A good fit matters as much as credentials.` },
  'inadequate-maintenance': { title: 'What Counts as Inadequate Property Maintenance in Georgia?', category: 'Premises Liability', body: `# Inadequate Maintenance

Property owners in Georgia have a legal duty to maintain their premises in a reasonably safe condition. When buildings, walkways, equipment, or safety systems are not properly maintained, serious injuries can occur.

Under O.C.G.A. § 51-3-1, owners and occupiers of land who invite others onto their property must exercise ordinary care to keep the premises safe. Failure to inspect, repair, or maintain property can result in liability for injuries caused by unsafe conditions.

Jones & Booth Law has represented and continues to represent individuals across Georgia who have been injured due to negligent property maintenance in commercial buildings, apartment complexes, retail stores, hotels, and other properties.

Inadequate maintenance cases often involve preventable hazards that were ignored for weeks, months, or even years.

---

## Common Examples of Inadequate Maintenance

- Broken staircases or handrails
- Cracked sidewalks or uneven pavement
- Roof leaks causing interior hazards
- Structural deterioration
- Faulty elevators or escalators
- Malfunctioning security gates
- Neglected lighting in parking lots
- HVAC leaks creating slippery floors
- Mold or water damage
- Unrepaired flooring defects

Property owners are expected to conduct reasonable inspections and correct known hazards within a reasonable timeframe.

---

## Early Action Matters

Property owners may repair hazards immediately after an accident occurs. Without prompt investigation, key evidence can disappear.

We move quickly to:

- Document conditions
- Send preservation letters
- Obtain maintenance records
- Interview witnesses
- Evaluate code compliance

If you were injured due to unsafe or poorly maintained property in Georgia, Jones & Booth Law can evaluate your claim and protect your rights.

Contact us today to schedule a consultation.` },
  'motor-vehicle-accidents': { title: 'What Should I Know About Motor Vehicle Accidents in Georgia?', category: 'Motor Vehicle', body: `# Motor Vehicle Accidents

Motor vehicle accidents are one of the leading causes of serious injury and wrongful death in Georgia. Whether the crash involved a passenger vehicle, commercial truck, motorcycle, or rideshare driver, the aftermath can be overwhelming.

Medical bills accumulate quickly. Insurance companies begin investigating immediately. Important evidence can disappear within days.

At Jones & Booth Law, we represent individuals and families across Georgia who have been injured due to negligent drivers. Our firm handles complex motor vehicle accident claims involving catastrophic injuries, disputed liability, and significant insurance coverage issues.

If you were injured in a crash anywhere in Georgia, you may have the right to recover compensation under Georgia law. Reach out to us immediately so we can ensure your rights are fully protected. Prompt action is crucial. Remember, you are not alone.

---

## Types of Motor Vehicle Accident Cases We Handle

We represent clients in a wide range of motor vehicle accident claims, including:

- Car accidents
- Truck and 18-wheeler accidents
- Motorcycle accidents
- Uber and Lyft accidents
- Drunk driving (DUI) accidents
- Commercial vehicle crashes
- Delivery vehicle accidents
- Multi-vehicle collisions
- Hit-and-run accidents
- Wrongful death claims arising from crashes

Each case type involves different insurance structures, liability standards, and investigative requirements.

---

## Common Causes of Motor Vehicle Accidents in Georgia

- Distracted driving
- Speeding
- Drunk driving
- Failure to yield
- Running red lights
- Improper lane changes
- Driver fatigue
- Unsafe commercial vehicle operation
- Poor vehicle maintenance

Identifying the true cause of a crash often requires accident reconstruction, vehicle data retrieval, and witness investigation.

---

## Serious Injuries Resulting From Vehicle Collisions

- Traumatic brain injury (TBI)
- Spinal cord injury
- Paralysis
- Broken bones
- Internal organ damage
- Severe burns
- Permanent disability
- Wrongful death

High-speed collisions and commercial truck accidents frequently result in catastrophic harm requiring long-term care.

---

## What Compensation Can Be Recovered?

In Georgia motor vehicle accident claims, compensation may include:

- Emergency medical expenses
- Hospitalization and surgery
- Rehabilitation and therapy
- Lost wages
- Loss of earning capacity
- Pain and suffering
- Emotional distress
- Property damage
- Punitive damages (in DUI or reckless cases)

Every case must be evaluated individually to determine full financial impact.

---

## Why Insurance Companies Act Quickly

Insurance carriers often contact injured individuals within days of a crash. Their goal is to:

- Obtain recorded statements
- Limit liability exposure
- Minimize settlement value
- Shift blame

Early legal representation helps preserve evidence and protect your claim from undervaluation.

---

## What To Do After a Wreck

1. Seek immediate medical attention.
2. Report the accident to law enforcement.
3. Avoid giving recorded statements without legal guidance.
4. Preserve photographs and documentation.
5. Consult an experienced motor vehicle accident attorney, like those of our firm.

Even seemingly minor injuries can develop into long-term medical conditions.

**26 Years of Accumulated Practice**

## Call for a Consultation
[Request a Consult](https://www.jonesboothlaw.com/contact)` },
  'motorcycle-accidents': { title: 'What Should I Know About Motorcycle Accidents in Georgia?', category: 'Motor Vehicle', body: `# Motorcycle Accident

Motorcyclists face unique dangers on Georgia roads. At Jones & Booth, we understand these challenges. Attorney Matt Jones, an experienced rider himself, combines his passion for motorcycles with a commitment to fighting for your rights.

When you choose us, you get a legal advocate who knows the road and is dedicated to protecting your interests. Let us be the strong support you need in your corner.

---

## Common Causes

- Left-turn collisions
- Blind spot accidents
- Unsafe lane changes
- Road hazards
- Distracted drivers

Despite the fact that many motorcycle incidents are not caused by the motorcyclist, Insurance companies often attempt to blame motorcyclists unfairly.

---

## Schedule Consultation

If you were injured in a Georgia motorcycle accident and suffered any of the following:

- Road rash
- Traumatic brain injury
- Spinal injuries
- Internal injuries
- Amputations

Please give us a call - we are ready to protect your rights! We'll get to work immediately to protect you and ensure you get what you deserve.` },
  'negligent-security': { title: 'What Is Negligent Security in Georgia?', category: 'Premises Liability', body: `# Negligent Security

Property owners may be liable for criminal acts committed on their premises when those acts were reasonably foreseeable. This is known as negligent security.

If you were assaulted at an apartment complex, hotel, parking lot, or retail location in Georgia, you may have a civil claim against the property owner.

---

## When Is a Property Owner Liable?

Liability may arise if:

- There were prior similar crimes
- The property lacked adequate lighting
- Security cameras were nonfunctional
- No security personnel were present
- Broken gates or locks were ignored

---

## What Compensation Can I Receive?

- Medical treatment
- Trauma counseling
- Lost income
- Pain and suffering

These cases often require extensive investigation of crime history and security practices.

Call us today for a free consultation to help determine the strength and value of your case!` },
  'paralysis': { title: 'What Should I Know About Paralysis Injury Claims in Georgia?', category: 'Catastrophic Injury', body: `# Paralysis Injuries

Paralysis is one of the most devastating injuries a person can suffer. Whether partial or complete, paralysis permanently alters mobility, independence, and quality of life.

Paralysis injuries often result from:

- Truck accidents
- Car accidents
- Falls from heights
- Construction accidents
- Workplace incidents
- Violent assaults

At Jones & Booth Law, we represent paralysis victims throughout Georgia in catastrophic injury claims.

---

## Types of Paralysis Injuries

### Paraplegia
Loss of function in the lower body, typically due to spinal cord injury in the thoracic or lumbar region.

### Quadriplegia (Tetraplegia)
Loss of function in all four limbs, typically caused by cervical spinal cord injury.

### Partial or Incomplete Paralysis
Limited motor function or sensation remains.

Each type requires different medical, rehabilitative, and long-term care planning.

---

## Lifetime Costs of Paralysis

- Emergency surgery
- Long-term hospitalization
- Physical therapy
- Occupational therapy
- Assistive devices
- Wheelchairs and adaptive vehicles
- Home modifications
- In-home nursing care

The lifetime cost of high-level paralysis can reach several million dollars.

---

## Compensation Available in Georgia

- Past and future medical expenses
- Lifetime care costs
- Lost earning capacity
- Pain and suffering
- Emotional distress
- Loss of consortium
- Punitive damages (in cases of extreme negligence)

Because paralysis claims involve significant damages, insurance carriers aggressively defend these cases. Early legal intervention helps preserve evidence and strengthen negotiation leverage.` },
  'premises-liability': { title: 'What Is Premises Liability in Georgia?', category: 'Premises Liability', body: `# Premises Liability

Property owners in Georgia have a legal responsibility to keep their premises reasonably safe. When they fail to inspect, repair, or warn about dangerous conditions, serious injuries can occur.

If you were injured on someone else's property — whether at a store, apartment complex, hotel, parking lot, or private residence — you may have a premises liability claim under Georgia law.

At Jones & Booth Law, we represent individuals across Georgia who have been harmed due to unsafe property conditions. These cases often involve powerful insurance carriers and complex legal standards. Early legal intervention is critical.

---

## Types of Premises Liability Cases We Handle

- Slip and fall accidents
- Trip and fall injuries
- Negligent security claims
- Inadequate maintenance cases
- Apartment complex assaults
- Swimming pool accidents
- Elevator and escalator injuries
- Falling merchandise injuries
- Unsafe stairway accidents
- Parking lot injuries

Each type of claim requires careful investigation into property conditions, inspection practices, and prior complaints.

---

## What Do I Need to Prove in Georgia to Be Successful in My Claim?

To recover compensation successfully, an injured person must generally prove:

1. The property owner had actual or constructive knowledge of a dangerous condition.
2. The injured person did not have equal or greater knowledge of the hazard.
3. The hazard actually caused the injury.
4. Damages to the person resulted.

Many premises liability cases turn on constructive knowledge — meaning the dangerous condition existed long enough that the owner should have discovered it through reasonable inspection.

Insurance companies often argue that hazards were "open and obvious." Strong evidence collection early in the case is essential.

---

## Common Causes of Unsafe Property Conditions

- Poor lighting
- Broken handrails
- Wet floors
- Uneven pavement
- Structural deterioration
- Inadequate security measures
- Code violations
- Failure to repair known hazards
- Failure to inspect regularly

Large retail chains, property management companies, and apartment complexes often maintain extensive insurance coverage and legal defense teams.

---

## Injuries Commonly Caused by Unsafe Property Conditions

- Traumatic brain injuries
- Spinal injuries
- Broken bones
- Hip fractures
- Torn ligaments
- Permanent disability
- Wrongful death

---

## Early Investigation and Action Matters

**Property owners may:**
- Repair hazards immediately after an accident
- Dispute the existence of dangerous conditions
- Destroy or overwrite surveillance footage
- Shift blame to the injured party

**We act quickly to:**
- Send preservation letters
- Obtain maintenance records
- Secure surveillance footage
- Interview witnesses
- Document unsafe conditions` },
  'real-estate-litigation': { title: 'What Is Real Estate Law Litigation in Georgia?', category: 'Real Estate Law', body: `# Services

## 02. Real Estate Law Litigation

### Tenant & Housing Rights

The practice of commercial real estate litigation concerns income-producing real estate properties and projects of a wide variety, including office buildings, retail centers, apartment buildings and condominium developments, hotels, industrial and specialty properties.

- Condemnation / Eminent Domain
- Fiduciary Litigation
- Real Estate Law Litigation
- Landlord/Tenant Litigation` },
  'rideshare-accidents': { title: 'What Should I Know About Uber & Lyft Accidents in Georgia?', category: 'Motor Vehicle', body: `# Uber & Lyft Accidents

Rideshare accidents involve complex insurance layers depending on the driver's app status.

## Why Rideshare Cases Are Complex

- Multiple insurance policies
- Corporate defense teams
- Disputes over app status
- Coverage gaps

If you've been involved in a motor vehicle collision with a rideshare, give us a call today so we can explain the different complexities and how they may or may not affect your case.

## Injured in a Georgia Rideshare Accident?

Give us a call today and we investigate the insurance layers and pursue full compensation, so you don't have to worry about anything except getting better.` },
  'should-i-hire-a-lawyer-after-a-minor-accident': { title: 'Do I Need a Lawyer After a "Minor" Car Accident?', category: 'Personal Injury', body: `**Often, yes — especially if you were injured.**

Insurance companies treat "minor" claims as opportunities to pay less. Injuries that seem small at first — neck pain, headaches, stiffness — can turn into long-term problems.

**Consider a lawyer if:**

- You went to the doctor or expect ongoing treatment
- The other driver or insurer disputes fault
- You're getting pressure to give a recorded statement
- The first settlement offer feels low
- You're missing work or have mounting bills

**You may not need one if:**

- There are no injuries, fault is clear, and property damage only is resolved fairly

**What does it cost to find out?**

Most personal injury attorneys offer a **free consultation**. Jones & Booth Law can review your case at no charge and explain your options.` },
  'slip-and-fall': { title: 'What Should I Know About Slip and Fall Claims in Georgia?', category: 'Premises Liability', body: `# Slip and Fall

Slip and fall accidents are among the most common premises liability claims in Georgia. Property owners have a legal duty under O.C.G.A. § 51-3-1 to keep their premises reasonably safe for invitees, which includes ensuring that any and all preventable trips, slips, and falls are prevented. When they fail to clean spills, repair hazards, or warn visitors of dangers, serious injuries can result.

Jones & Booth Law represents individuals across Georgia injured due to unsafe property conditions in stores, restaurants, apartment complexes, hotels, and commercial properties.

---

## Common Causes of Slip and Fall Accidents

- Wet floors without warning signs
- Recently mopped surfaces
- Leaking refrigeration units
- Poor lighting
- Broken handrails
- Uneven flooring
- Torn carpeting

---

## How to Recover for Slip and Fall

To recover compensation, we must establish:

1. The property owner had actual or constructive knowledge of the hazard.
2. The injured person lacked superior knowledge of the hazard.
3. The hazard directly caused the injury.

Insurance companies often argue the hazard was "open and obvious." Early investigation is critical.

We have successfully represented many individuals across Georgia injured due to unsafe property conditions in stores, restaurants, apartment complexes, hotels, and commercial properties. Call us today for a free consultation!` },
  'spinal-cord-injury': { title: 'What Should I Know About Spinal Cord Injury Claims in Georgia?', category: 'Catastrophic Injury', body: `# Spinal Cord Injuries

## Symptoms of Spinal Injury

- Paraplegia
- Quadriplegia
- Herniated discs
- Nerve damage

---

## Get Help Immediately

The sooner you receive help, the sooner you can begin the road to recovery. Spinal cord injuries often require immediate emergency intervention followed by extensive rehabilitation.

Even injuries classified as "incomplete" can result in chronic pain, nerve damage, muscle weakness, and long-term mobility limitations. In severe cases, individuals may require assistive devices, wheelchairs, or full-time caregiving support.

---

## Lifetime Financial Impact

Spinal injury cases often involve:

- Home modifications
- Wheelchair-accessible transportation
- Ongoing therapy
- In-home care

The lifetime cost of treating paralysis or significant spinal trauma can reach into the millions of dollars, making accurate future damage calculation essential in Georgia injury claims.

---

## Take Action Early

Because spinal cord injury cases involve substantial damages, insurance companies and corporate defendants aggressively defend these claims. Early case development is critical.

Our firm works with medical specialists, rehabilitation experts, and economic analysts to project lifetime care costs, lost earning potential, and necessary home or vehicle modifications.

We prepare every catastrophic spinal injury case as though it will proceed to trial.` },
  'swimming-pool-accidents': { title: 'What Should I Know About Swimming Pool Accidents in Georgia?', category: 'Premises Liability', body: `# Swimming Pool Accidents

Swimming pool accidents can result in catastrophic injury or wrongful death. Property owners must maintain pools safely and comply with Georgia safety standards.

---

## Common Examples of Swimming Pool Accidents

- Drowning incidents
- Near-drowning brain injury
- Lack of fencing
- Defective pool drains
- Failure to supervise

Children may be protected under the "attractive nuisance" doctrine, which increases a property owner's duty when hazards are likely to attract minors.

---

## Early Action Matters

Pool owners may repair hazards immediately after an accident occurs. Without prompt investigation, key evidence can disappear.

We move quickly to:

- Document conditions
- Send preservation letters
- Obtain maintenance records
- Interview witnesses
- Evaluate code compliance

If you or a family member were injured at a swimming pool due to unsafe or poorly maintained property in Georgia, Jones & Booth Law can protect your rights.

Contact us today to schedule a consultation.` },
  'traumatic-brain-injury': { title: 'What Should I Know About Traumatic Brain Injury (TBI) Claims in Georgia?', category: 'Catastrophic Injury', body: `# Traumatic Brain Injury (TBI)

A traumatic brain injury can permanently alter cognitive function, personality, and physical ability. TBIs frequently occur in:

- Car accidents
- Truck accidents
- Falls
- Workplace accidents

---

## Long-Term Impact and Damages

TBI cases require:

- Neurological experts
- Life care planning
- Future wage loss analysis

Compensation may include lifetime medical care and loss of earning capacity.

---

## Symptoms of Traumatic Brain Injury

- Memory loss
- Headaches
- Mood changes
- Cognitive impairment
- Loss of coordination
- Dizziness

---

## TBI Often Misunderstood

Traumatic brain injuries are often misunderstood because symptoms may not appear immediately after an accident. Many TBI victims initially believe they suffered only a concussion, only to experience worsening cognitive issues, memory loss, concentration problems, mood changes, and neurological complications weeks later.

In Georgia personal injury cases, delayed diagnosis does not eliminate your right to pursue compensation. Prompt neurological evaluation and thorough documentation are critical to protecting your claim.

---

## Early Action Needed

Insurance companies frequently attempt to minimize traumatic brain injury cases by arguing that imaging scans appear "normal." However, many TBIs do not show up clearly on standard CT scans or MRIs. Mild to moderate brain injuries can still produce severe cognitive and functional impairment.

Our firm works with neurologists, neuropsychologists, and life care planners to demonstrate the full medical and financial impact of a brain injury.

Call us today for a free evaluation.` },
  'truck-accidents': { title: 'What Should I Know About Truck & 18-Wheeler Accidents in Georgia?', category: 'Motor Vehicle', body: `# Truck Accident (18 Wheeler and Other Commercial Vehicles)

Truck accidents in Georgia often result in catastrophic injuries due to the size and weight of commercial vehicles. These cases are more complex than standard car accidents because they may involve federal trucking regulations and multiple liable parties.

---

## Why Truck Accidents are Different

While similar in many ways, collisions involving commercial vehicles are different from regular motor vehicle collisions because of additional complexities like:

- Federal Motor Carrier Safety Regulations (FMCSA)
- Commercial insurance policies
- Corporate defendants
- Black box data evidence
- Driver log violations

---

## Common Causes and Who is Responsible

### Common Causes of Georgia Truck Accidents

- Driver fatigue
- Overloaded trailers
- Improper maintenance
- Distracted commercial drivers
- Improper lane changes
- Jackknife accidents

### Who May Be Liable?

- The truck driver
- The trucking company
- Maintenance providers
- Cargo loading companies
- Vehicle manufacturers

---

## Early Action Matters

Trucking companies deploy investigators immediately after a crash. Evidence such as black box data and driver logs can disappear quickly.

If you or a loved one was injured in a commercial vehicle accident in Georgia, schedule a consultation today with the specialists of Jones & Booth Law.` },
  'undue-influence': { title: 'What Is an Undue Influence Claim in Georgia?', category: 'Estate & Probate', body: `# UNDUE INFLUENCE CLAIMS

Undue influence occurs when someone applies improper pressure on an individual, leading them to alter their estate plan in a way that may not truly reflect their wishes. This can be especially concerning for:

- Elderly testators
- Caregiver relationships
- Isolated individuals
- Sudden changes to estate plans

---

## Indicators of Undue Influence

- Sudden changes benefiting one person disproportionately
- Isolation from family members
- Dependency on the influencer
- Control over finances
- Deteriorating mental health

Proving undue influence requires detailed factual investigation and often circumstantial evidence.

---

## Why These Cases Are Complex

Undue influence is rarely documented directly. Successful claims require:

- Medical record review
- Witness testimony
- Financial pattern analysis
- Timeline reconstruction` },
  'what-counts-as-a-commercial-lease-dispute': { title: 'What Counts as a Commercial Lease Dispute?', category: 'Real Estate Law', body: `**Any disagreement over a business lease terms, money, or use of the property.**

Common disputes we see in Atlanta and across Georgia:

- Non-payment of rent or CAM (common area maintenance) charges
- Alleged lease breaches by landlord or tenant
- Co-tenancy or exclusivity clause violations
- Holdover tenants who won't leave after lease expiration
- Disputes over lease renewal options or permitted use
- Assignment or sublease disagreements

**How is commercial lease law different from residential?**

Georgia courts generally **enforce commercial lease terms as written**. There is less tenant-protection statute than in residential cases. The lease you signed usually controls.

**Landlord or tenant — does it matter?**

We represent both. The right strategy depends on your lease language, payment history, and whether negotiation or court is the better path.

**When should I call a lawyer?**

Before you stop paying rent, lock out a tenant, or sign a settlement. Early advice prevents costly mistakes.` },
  'what-is-a-quiet-title-action': { title: 'What Is a Quiet Title Action?', category: 'Real Estate Law', body: `**A lawsuit to clear a cloud on your property title.**

If something casts doubt on who owns your property — or what liens exist — you may not be able to sell, refinance, or transfer it cleanly. A quiet title action asks a Georgia Superior Court to settle competing claims once and for all.

**Common reasons to file:**

- Gaps or errors in the chain of title
- Boundary line disputes
- Heir property with unclear ownership
- Improperly released mortgages or liens
- Adverse possession claims
- Defects after a tax sale

**How long does it take?**

Often **3–6 months**, depending on how many parties must be notified and whether anyone contests the claim.

**Do I need a lawyer?**

Title issues are document-heavy and procedural. Missing a required party or notice step can stall or kill your case.

Jones & Booth Law handles quiet title actions throughout Georgia.` },
  'what-should-i-do-after-a-car-accident': { title: 'What Should I Do After a Car Accident in Georgia?', category: 'Personal Injury', body: `**Call 911 if anyone is hurt.** Your health comes first. Even minor collisions can cause injuries that show up hours or days later.

**Move to safety if you can.** Turn on hazard lights. Stay out of traffic.

**Get a police report.** It creates an official record. Give facts only — don't guess at fault.

**Take photos.** Capture vehicle damage, plates, road conditions, signs, and any visible injuries.

**Exchange info.** Names, phone numbers, insurance, and driver's license details for all drivers and witnesses.

**See a doctor — even if you feel fine.** Whiplash and internal injuries often appear later. Medical records link your injuries to the crash.

**Notify your insurer promptly.** Most policies require timely reporting. Stick to basic facts.

**Don't give recorded statements to the other driver's insurer** without legal advice. Don't post about the crash on social media.

**Talk to a personal injury attorney** before accepting any settlement. Deadlines and fault disputes can cost you if you wait.` },
  'when-can-a-landlord-keep-my-security-deposit': { title: 'When Can a Landlord Keep My Security Deposit in Georgia?', category: 'Real Estate Law', body: `**Only for legitimate deductions — and they must prove it in writing.**

Under O.C.G.A. § 44-7-30 et seq., landlords must return your security deposit within **one month** after the lease ends, along with an **itemized list** of any deductions.

**Valid reasons to deduct may include:**

- Unpaid rent
- Damage beyond normal wear and tear
- Unpaid utilities or fees spelled out in the lease
- Cleaning costs if you left the unit unreasonably dirty

**What's NOT allowed:**

- Keeping the deposit with no explanation
- Charging for ordinary wear and tear
- Missing the one-month deadline without consequences

**What if they wrongfully withhold it?**

You may recover the deposit amount **plus attorney's fees** in many cases. Document move-in and move-out condition with photos.

**Tenant or landlord?**

We represent both sides in deposit disputes across Atlanta and North Georgia.` },
  'when-do-i-need-a-partition-action': { title: 'When Do I Need a Partition Action?', category: 'Real Estate Law', body: `**When co-owners of property can't agree on what to do with it.**

A partition action is a Georgia Superior Court proceeding under O.C.G.A. § 44-6-140 et seq. that forces a division or sale of shared real estate when owners won't cooperate.

**Typical situations:**

- Inherited property split among heirs who disagree
- Ex-partners or ex-spouses who co-own and one wants to sell
- Business partners dissolving a joint investment
- One owner refuses buyout or sale negotiations

**What can the court order?**

- **Partition in kind** — physically divide the land if that's practical (rare for most residential or commercial parcels)
- **Partition by sale** — sell the property and split proceeds by ownership share

**Can one owner block a sale forever?**

Not indefinitely. If co-owners can't agree, the court can order a sale over one owner's objection.

**Talk to us before you stop paying or move out.** Partition cases move faster with clean title records and a clear ownership history.` },
  'will-contests-trust-disputes': { title: 'What Are Will Contests & Trust Disputes in Georgia?', category: 'Estate & Probate', body: `# Will Contests and Trust Disputes

When a loved one passes away, families need clarity — not conflict. Yet disputes over wills and trusts are on the rise, particularly when large estates, blended families, or last-minute changes are involved.

If you suspect that a will or trust doesn't truly reflect your loved one's wishes — or was the product of undue influence, lack of capacity, or improper execution — you may have the right to challenge it in court.

---

## Grounds to Contest a Will or Trust in Georgia

- Lack of testamentary capacity
- Undue influence
- Fraud or forgery
- Improper execution
- Revocation disputes
- Coercion

Trust disputes may also arise when trustees mismanage assets or interpret trust language improperly.

---

## What Is at Stake?

- Invalidation of the document
- Reinstatement of a prior will
- Removal of a trustee
- Redistribution of estate assets

---

## Why Early Legal Action Is Critical

Georgia probate courts follow strict procedural rules. If you do not file an objection within the required timeframe, you may lose your right to challenge the estate plan permanently.

Our firm conducts detailed investigations including:
- Reviewing medical records
- Examining financial activity
- Interviewing witnesses
- Analyzing drafting attorney files
- Securing handwriting experts when necessary` },
  'workplace-industrial-injury': { title: 'What Should I Know About Workplace & Industrial Injuries in Georgia?', category: 'Workplace Injury', body: `# Workplace/Industrial Injuries

Workplace and industrial accidents can cause devastating injuries that permanently affect a person's ability to earn a living and support their family. While workers' compensation provides limited benefits, many serious workplace accidents involve third-party negligence claims that allow for substantially greater financial recovery.

If you were injured on the job in Georgia, you may have more legal options than you realize.

---

## Workplace Injury Claims vs. Workers Compensation Claims

Georgia's workers' compensation system does NOT allow recovery for:

- Pain and suffering
- Emotional distress
- Full lost wages
- Loss of earning capacity

However, when a third party contributed to the accident, you may pursue a personal injury lawsuit in addition to workers' compensation benefits.

---

## Types of Workplace & Industrial Accidents We Handle

- Construction site accidents
- Industrial machinery failures
- Equipment malfunctions
- Forklift and warehouse accidents
- Electrical injuries
- Chemical exposure
- Crane accidents
- Scaffold collapses
- Trench collapses
- Delivery driver accidents
- Commercial vehicle crashes while working
- Contractor negligence
- Unsafe premises conditions

---

## Third-Party Liability

You may have a third-party claim if your injury was caused by:

- A negligent subcontractor
- A general contractor's unsafe practices
- A defective machine or tool
- A negligent property owner
- A careless driver while you were working
- Improper equipment maintenance

---

## Why Immediate Action Matters

We act promptly to:

- Preserve equipment and machinery
- Secure maintenance logs
- Review OSHA records
- Obtain incident reports
- Interview witnesses
- Analyze site safety practices` },
  'workplace-injuries': { title: 'What Should I Know About Workplace Injuries in Georgia?', category: 'Workplace Injury', body: `# Workplace Injuries

Workplace injuries can leave employees facing medical bills, lost wages, and uncertainty about their future. While Georgia's workers' compensation system provides certain benefits, it does not allow recovery for pain and suffering.

In some cases, injured workers may have additional third-party claims that significantly increase potential compensation.

Jones & Booth Law evaluates workplace injuries to determine whether negligence by someone other than the employer contributed to the accident.

---

## Common Workplace Injury Scenarios

- Machinery accidents
- Slip and fall incidents
- Warehouse accidents
- Delivery driver accidents
- Commercial vehicle crashes
- Exposure to hazardous materials
- Construction-related injuries

---

## When a Third-Party Claim May Apply

You may have a personal injury claim in addition to workers' compensation if:

- A subcontractor caused the injury
- A defective product contributed to the accident
- A negligent driver struck you while working
- A property owner failed to maintain safe premises

These claims allow recovery for:

- Pain and suffering
- Full lost wages
- Long-term earning loss
- Emotional distress

---

## Why Early Case Evaluation Matters

Insurance carriers often attempt to limit injured workers to workers' compensation benefits only. Proper legal analysis can identify additional liable parties and preserve evidence early.` },
  'wrongful-death': { title: 'What Is a Wrongful Death Claim in Georgia?', category: 'Catastrophic Injury', body: `# Wrongful Death

When a person's life is taken due to someone else's negligence or misconduct, Georgia law allows surviving family members to pursue a wrongful death claim. While no legal action can ever undo the loss, a civil claim can provide financial stability and hold the responsible party accountable.

Surviving family members may recover the "full value of the life" of the deceased. This includes both economic and intangible components.

At Jones & Booth Law, we represent families across Georgia in wrongful death cases involving motor vehicle accidents, trucking collisions, unsafe property conditions, workplace incidents, and other acts of negligence.

---

## Who Can File a Wrongful Death Claim?

Georgia law sets a strict order of priority:

1. Surviving spouse
2. Children (if no spouse)
3. Parents (if no spouse or children)
4. Estate representative

The claim is brought for the full value of the life of the decedent.

---

## What is the "Full Value of Life" in Georgia?

**Economic Value:**
- Lost wages over the expected lifetime
- Lost benefits
- Lost services

**Intangible Value:**
- Loss of enjoyment of life
- Loss of experiences
- Loss of relationships
- Loss of purpose

Unlike some states, Georgia does not cap wrongful death damages in most negligence cases.

---

## Common Causes of Wrongful Death in Georgia

- Car accidents
- Truck accidents
- DUI collisions
- Motorcycle crashes
- Catastrophic workplace incidents
- Premises liability accidents
- Negligent security incidents
- Product defects

In cases involving egregious misconduct, punitive damages may also apply.

---

## Contact Us

If your family has experienced the heart-wrenching loss of a loved one due to negligence in Georgia, you don't have to face this tough journey alone. Reach out to Jones & Booth Law today for compassionate guidance and to explore your legal options.` }
};
